import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonService } from '../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getFormError, emailPhoneUseridValidator } from '../util';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ClipboardService } from 'node_modules/ngx-clipboard';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ContactRishiDialogComponent } from '../contact-rishi-dialog/contact-rishi-dialog.component';

declare var $: any, google: any;
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit {
  private _map = null;
  consultationform: FormGroup;
  getFormError = getFormError;
  message = '';
  error = '';
  /*
  blogs : any= [];
  showMoreBlogs: boolean = false;
  eventData : any= [];
  upcomingEvents : any= [];
  memberUpcomingEvents : any= [];
  chapterUpcomingEvents : any= [];
  regionalUpcomingEvents : any= [];
  globalUpcomingEvents : any= [];
  pastEvents : any= [];
  showMoreEvents: boolean = false;
  contentData : any= [];
  */
  skills : any= [];
  todayDate=new Date();
  showConfirmation = false;
  ServiceAddress = {Street:'',City:'', State:'', County:'', Country:'',Zip:'', Lat:0, Lng:0, Error:''};
  selectedCategory = null;
  selectedCSkill = null;
  shoqQRCode = true;

  constructor(private fb: FormBuilder, public cs: CommonService, private route: ActivatedRoute, private router: Router, private location: Location
    , private _snackBar: MatSnackBar, private _clipboardService: ClipboardService, private dialog: MatDialog
  ) {
    this.route.paramMap.subscribe((params: any) => {
      if(params != null && params.params != null && params.params.id != null && params.params.id != ''){
        var selectedCategoryId = params.params.id.toLowerCase();
        if(selectedCategoryId != null && selectedCategoryId > 0){
          //reload enums
          this.cs.readEnums().then((result: any) => {
            var selectedSkill = this.cs.Skills.filter(item => item.Id == selectedCategoryId);
            if(selectedSkill != null && selectedSkill.length > 0){
              //update drop downs
              this.consultationform.controls.Category.setValue(selectedSkill[0].Category);
              this.categoryChange(selectedSkill[0].Category);
              this.consultationform.controls.RequestedSkill.setValue(selectedSkill[0].Id)
            }

          }).catch((err) => {
          });
        }
      }
    });
  }

  ngOnInit() {    

    this.cs.spinner = false;
    this.showConfirmation = false;
    //this.readData();

    this.consultationform = this.fb.group({
      Name: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      Description: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      RequestedDateTime: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      Category: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      RequestedSkill: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      FirstName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      LastName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      Email: ['', [Validators.required, Validators.email, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      PhoneNumber: ['', [Validators.required, Validators.pattern("[0-9]{10}")]],
      ServiceAddress: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
    });
  }
 openContactRishiDialog(item) {
    const dialogRef = this.dialog.open(ContactRishiDialogComponent, {
      width: '400px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("Form submitted:", result);
        // Handle the data (send to backend, WhatsApp API, etc)
      }
    });
  }

  handleCurrentLocationAddressChange(event) {
    var street_number = '';
    var route = '';

    this.ServiceAddress = {Street:'',City:'', State:'', County:'', Country:'',Zip:'', Lat:0, Lng:0, Error:''};

    for (let address of event.address_components) {
      if (address.types.indexOf("locality") != -1) {
        this.ServiceAddress.City = address.short_name
      } else if (address.types.indexOf("route") != -1) {
        route = address.short_name;
      } else if (address.types.indexOf("street_number") != -1) {
        street_number = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_1") != -1) {
        this.ServiceAddress.State = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_2") != -1) {
        this.ServiceAddress.County = address.short_name;
      } else if (address.types.indexOf('postal_code') != -1) {
        this.ServiceAddress.Zip = address.long_name;
      } else if (address.types.indexOf('country') != -1) {
        this.ServiceAddress.Country = address.short_name;
      }
    }
    if(this.ServiceAddress.Country == null || this.ServiceAddress.Country == undefined || this.ServiceAddress.Country == '') {
      this.ServiceAddress.City = '';
      return;
    }

    this.ServiceAddress.Lat = event.geometry.location.lat();
    this.ServiceAddress.Lng = event.geometry.location.lng();

    if(street_number != null && street_number.length > 0){
      this.ServiceAddress.Street = street_number;
    }
    if(route != null && route.length > 0){
      if(this.ServiceAddress.Street != null &&  this.ServiceAddress.Street.length > 0){
        this.ServiceAddress.Street += ' ';
      }
      this.ServiceAddress.Street += route;
    }

    this.ServiceAddress.Error = '';
  }

  categoryChange(categoryName){
    if(categoryName == null){
      let data = this.consultationform.getRawValue();
      categoryName = data.Category;
    }
    this.skills = this.cs.Skills.filter(item => item.Category == categoryName );
    this.selectedCategory = this.cs.SkillCategories.find(skill => skill.Name === categoryName);
    this.selectedCSkill = {};
    this.consultationform.get('RequestedSkill').reset();
    this.location.replaceState('/');
  }

  skillChange(categoryName){
    let data = this.consultationform.getRawValue();
    this.selectedCSkill = this.skills.find(skill => skill.Id === data.RequestedSkill);
    this.location.replaceState('/consultation/' + this.selectedCSkill.Id.toString());
  }

  ngAfterViewInit() {
    if(this._map == null)
    {
      var mapDiv = document.createElement('div');
      this._map = new google.maps.Map(mapDiv);      
    }
  }
  shareZelle(){
    var ZelleId = 'RishiYog';

    this._clipboardService.copy(ZelleId);
    this._snackBar.open("Zelle Id Copied to Clipboard: " + ZelleId, "", {
      duration: 2000,
    });
  }

  share(item){
    var url = 'https://item.rishiyog.org/api/public/detail/item/' + item.Id;
    this._clipboardService.copy(url);
    this._snackBar.open("Copied to Clipboard", "", {
      duration: 2000,
    });
  }

  consultationsubmit(){
    if(this.ServiceAddress == null || (this.ServiceAddress != null && (this.ServiceAddress.City == null || this.ServiceAddress.City == ''))){
    this.ServiceAddress = {Street:'',City:'', State:'', County:'', Country:'',Zip:'', Lat:0, Lng:0, Error:''};
      this.ServiceAddress.Error = 'Please select an address from location auto complete';
      if (this.consultationform.invalid) {
        this.consultationform.markAllAsTouched();
      }
      return;
    }
    if (this.consultationform.invalid) {
      this.consultationform.markAllAsTouched();
      return;
    }
    let data = this.consultationform.getRawValue();
    data.ServiceAddress = this.ServiceAddress;

    this.cs.request('/public/consult', 'post', data).then((res: any) => {
      if (res.Status == 200) {
        this.message = res.Message;
        this.showConfirmation = true;
      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });
  }
  continue(){
    this.ngOnInit();
    this.router.navigateByUrl('/');
  }

  qrCode(){
    this.shoqQRCode = !this.shoqQRCode;
  }
/*
  readData(){
    this.cs.request('/public/events', 'get').then((res: any) => {
      if (res.Status == 200) {
        var currentDate = new Date();
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        this.eventData = res.Data;
        this.upcomingEvents = this.eventData.filter(item => new Date(item.EventDateTime) >= currentDate );
        this.memberUpcomingEvents = this.eventData.filter(item => this.cs.enumTable.EventType[item.Type].Value == 'Member' && new Date(item.EventDateTime) >= currentDate );
        this.chapterUpcomingEvents = this.eventData.filter(item => this.cs.enumTable.EventType[item.Type].Value == 'Chapter' && new Date(item.EventDateTime) >= currentDate );
        this.regionalUpcomingEvents = this.eventData.filter(item => this.cs.enumTable.EventType[item.Type].Value == 'Regional' && new Date(item.EventDateTime) >= currentDate );
        this.globalUpcomingEvents = this.eventData.filter(item => this.cs.enumTable.EventType[item.Type].Value == 'Global' && new Date(item.EventDateTime) >= currentDate );

        this.pastEvents = this.eventData.filter(item =>{
          const itemDateOnly = new Date(item.timestamp.getFullYear(), item.timestamp.getMonth(), item.timestamp.getDate());
          return itemDateOnly.getTime() === currentDate.getTime();
        }).sort(function(a, b) {
          if( new Date(b.EventDateTime) >= new Date(a.EventDateTime)) return 1;
          return -1;
        });

        if(this.pastEvents.length > 3){
          this.showMoreEvents = true;
          this.pastEvents = this.pastEvents.slice(0, 3);
        }
        this.cs.request('/public/contentsbylocation?location=0', 'get').then((res: any) => {
          if (res.Status == 200) {
            this.contentData = res.Data;
          } else {
            this.error = res.Message;
          }
        }).catch((err) => {
        });
      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });

    this.cs.request('/public/blogs', 'get').then((res: any) => {
      if (res.Status == 200) {
        this.blogs = res.Data;
        if(this.blogs.length > 3){
          this.showMoreBlogs = true;
          this.blogs = this.blogs.slice(0, 3);
        }

      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });
  }
    */
}
